// Generated by CoffeeScript 2.7.0
var Vertex;

export default Vertex = {
  props: {
    vertex: {
      type: [Skylark.App.Model.YetAnotherWorkflow.Vertex, Skylark.App.Model.YetAnotherWorkflow.Graph],
      required: true
    },
    selectedVertices: {
      type: Array,
      default: function() {
        return [];
      }
    },
    vertexSize: {
      required: true
    },
    dragStates: Object,
    zoom: Number,
    isPreparedVertex: {
      type: Boolean,
      default: false
    }
  },
  inject: ['adjustByZoom'],
  computed: {
    vertexStyle: function() {
      return {
        width: this.vertexSize.width + 'px',
        height: this.vertexSize.height + 'px',
        left: this.vertex.metadata.position.x + 'px',
        top: this.vertex.metadata.position.y + 'px'
      };
    },
    statusClass: function() {
      return {
        focused: _.contains(this.selectedVertices, this.vertex),
        danger: this.vertex._status === 'danger',
        junior: this.isGraph
      };
    },
    typeClass: function() {
      if (this.isGraph) {
        return 'slp-dashed-square-o';
      } else if (this.vertex.isFinal) {
        return 'slp-power-off';
      } else if (this.vertex.isInitial) {
        return 'slp-play-circle-o';
      } else if (this.vertex.name === '机器节点') {
        return 'slp-node-robot';
      } else {
        return 'slp-list-square-check-o';
      }
    },
    isGraph: function() {
      return Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(this.vertex);
    }
  },
  template: `<div class="graph-vertex"
     :class='statusClass'
     :style='vertexStyle'
     @mousedown='mousedownFunc'
     @mouseover='mouseoverFunc'
     @mouseout='mouseoutFunc'>
  <div class="vertex-content justify-box">
    <div class="vertex-tip">
      <i :class='typeClass'></i>
    </div>
    <span class='content text-ellipsis'>{{ vertex.name || '流程节点' }}</span>
    <div class="vertex-tip clickable" v-if='isGraph' @mouseup='enterChildGraphIfNeed'>
      <i class="slp-pencil-square"></i>
    </div>
  </div>
  <div class="vertex-control"
       v-if="!vertex.isFinal"
       v-for='dir in [1, 2, -1, -2]'
       :style='_controlPosition(dir)'
       @mousedown="ctrlMousedownFunc(dir, $event)"
       :key='dir'>
    <span></span>
  </div>
</div>`,
  created: function() {
    return _.each(['mousemove', 'mouseup', 'mouseover', 'mouseout', 'ctrlMousemove', 'ctrlMouseup'], (event_type) => {
      return this[`${event_type}Func`] = this[event_type].bind(this);
    });
  },
  methods: {
    enterChildGraphIfNeed: function() {
      if (!this.isGraph) {
        return;
      }
      if (this.dragStates.enable) {
        return;
      }
      return this.$emit('enterChildGraph', this.vertex);
    },
    ctrlMousedownFunc: function(position, event) {
      event.stopPropagation();
      if (event.which !== 1) {
        return;
      }
      this.dragStates.start = {
        x: event.clientX,
        y: event.clientY
      };
      this.dragStates.dir = position;
      document.body.addEventListener('mousemove', this.ctrlMousemoveFunc, false);
      return document.body.addEventListener('mouseup', this.ctrlMouseupFunc, false);
    },
    ctrlMousemove: function(event) {
      var delta_x, delta_y, position, vertex_position;
      this.dragStates.enable = true;
      delta_x = this.adjustByZoom(event.clientX - this.dragStates.start.x);
      delta_y = this.adjustByZoom(event.clientY - this.dragStates.start.y);
      vertex_position = this.vertex.metadata.position;
      position = (function() {
        switch (this.dragStates.dir) {
          case 1:
            return {
              x: vertex_position.x,
              y: vertex_position.y - this.vertexSize.height - 2 * this.vertexSize.buffer_width
            };
          case -1:
            return {
              x: vertex_position.x,
              y: vertex_position.y + this.vertexSize.height + 2 * this.vertexSize.buffer_width
            };
          case 2:
            return {
              x: vertex_position.x + this.vertexSize.width + 2 * this.vertexSize.buffer_width,
              y: vertex_position.y
            };
          case -2:
            return {
              x: vertex_position.x - this.vertexSize.width - 2 * this.vertexSize.buffer_width,
              y: vertex_position.y
            };
        }
      }).call(this);
      return this.$emit('addPreparedEdge', {
        from: this.isGraph ? this.vertex.final_vertex : this.vertex,
        metadata: {
          connection_direction: {
            from: this.dragStates.dir,
            to: -1 * this.dragStates.dir
          },
          uncentain_key: 'to'
        },
        _status: 'uncentainVertex',
        to: {
          metadata: {
            position: {
              x: position.x + delta_x,
              y: position.y + delta_y
            }
          }
        }
      });
    },
    ctrlMouseup: function(event) {
      document.body.removeEventListener('mousemove', this.ctrlMousemoveFunc, false);
      document.body.removeEventListener('mouseup', this.ctrlMouseupFunc, false);
      if (this.dragStates.enable) {
        this.$emit('prepareEdgeEnd');
      }
      return this._removeStates();
    },
    mouseout: function(event) {
      var dir;
      // 如果由当前元素移入内部的子元素，则不认为是out了
      if (this.$el.contains(event.relatedTarget)) {
        return;
      }
      dir = this._getEnterOrLeaveDirection(event);
      return this.$emit('leaveVertex', this.vertex, dir);
    },
    mouseover: function(event) {
      var dir;
      // 如果是从内部的子元素移出到当前元素，应忽视
      if (this.$el.contains(event.relatedTarget)) {
        return;
      }
      dir = this._getEnterOrLeaveDirection(event);
      return this.$emit('enterVertex', this.vertex, dir);
    },
    mousedownFunc: function(event) {
      event.stopPropagation();
      // 不是左键
      if (event.which !== 1) {
        return;
      }
      this.dragStates.start = {
        x: event.clientX,
        y: event.clientY
      };
      // 如果当前节点是被选中的节点，则拖动所有选中的节点
      this.dragStates.original_data = this.statusClass.focused ? _.map(this.selectedVertices, function(vertex) {
        return _.clone(vertex.metadata.position);
      // 仅拖动自己
      }) : _.clone(this.vertex.metadata.position);
      document.body.addEventListener('mousemove', this.mousemoveFunc, false);
      return document.body.addEventListener('mouseup', this.mouseupFunc, false);
    },
    mousemove: function(event) {
      this.dragStates.enable = true;
      return this._dragMove(event);
    },
    mouseup: function(event) {
      document.body.removeEventListener('mousemove', this.mousemoveFunc, false);
      document.body.removeEventListener('mouseup', this.mouseupFunc, false);
      if (this.dragStates.enable) {
        this._dragMove(event);
        if (this.statusClass.focused) {
          this.$emit('limitVerticesPosition', this.selectedVertices);
          _.each(this.selectedVertices, function(vertex) {
            return vertex.update();
          });
        } else {
          this.$emit('limitVerticesPosition', [this.vertex]);
          this.vertex.update();
        }
      } else {
        this.$emit('focusVertex', this.vertex);
      }
      return this._removeStates();
    },
    _removeStates: function() {
      this.dragStates.start = {
        x: 0,
        y: 0
      };
      this.dragStates.dir = 1;
      this.dragStates.enable = false;
      return this.dragStates.original_data = [];
    },
    _dragMove: function(event) {
      var delta, original_data, svg_rect;
      if (this.isPreparedVertex) {
        svg_rect = this.$parent.$refs.svgRef.getBoundingClientRect();
        return this.vertex.updatePosition({
          x: event.clientX - ((svg_rect.left + this.vertexSize.width / 2) * this.zoom / 10),
          y: event.clientY - ((svg_rect.top + this.vertexSize.height / 2) * this.zoom / 10)
        });
      } else {
        delta = {
          x: event.clientX - this.dragStates.start.x,
          y: event.clientY - this.dragStates.start.y
        };
        _.each(delta, (v, k) => {
          return delta[k] = this.adjustByZoom(v);
        });
        original_data = this.dragStates.original_data;
        if (this.statusClass.focused) {
          return _.each(this.selectedVertices, function(vertex, index) {
            var original_position;
            original_position = original_data[index];
            return vertex.updatePosition({
              x: original_position.x + delta.x,
              y: original_position.y + delta.y
            });
          });
        } else {
          return this.vertex.updatePosition({
            x: original_data.x + delta.x,
            y: original_data.y + delta.y
          });
        }
      }
    },
    _getEnterOrLeaveDirection: function(event) {
      var delta_x, rect, scaled_delta_y;
      rect = event.target.getBoundingClientRect();
      delta_x = this.adjustByZoom(event.clientX) - (rect.left + rect.width / 2);
      // 消除矩形的影响，变为等效的正方形
      scaled_delta_y = (this.adjustByZoom(event.clientY) - (rect.top + rect.height / 2)) * rect.width / rect.height;
      if (Math.abs(scaled_delta_y) >= Math.abs(delta_x)) {
        if (scaled_delta_y >= 0) {
          return -1;
        } else {
          return 1;
        }
      } else {
        if (delta_x > 0) {
          return 2;
        } else {
          return -2;
        }
      }
    },
    _controlPosition: function(dir) {
      switch (dir) {
        case 1:
          return {
            top: 0,
            left: this.vertexSize.width / 2 + 'px'
          };
        case -1:
          return {
            top: this.vertexSize.height + 'px',
            left: this.vertexSize.width / 2 + 'px'
          };
        case 2:
          return {
            top: this.vertexSize.height / 2 + 'px',
            left: this.vertexSize.width + 'px'
          };
        case -2:
          return {
            top: this.vertexSize.height / 2 + 'px',
            left: 0
          };
      }
    }
  }
};
